// src/reducers/sessionsReducer.js
const initialState = {
  loading: false,
  data: {}, // per-user map: { [userId]: { data: {...sessionData}, loading, error, ending?, endError? } }
  error: false,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SESSION_START_REQ": {
      const userId = action.meta?.userId || "anon";
      return {
        ...state,
        loading: true,
        error: false,
        data: {
          ...state.data,
          [userId]: {
            ...(state.data[userId] || {}),
            loading: true,
            error: false,
          },
        },
      };
    }

    case "SESSION_START_SUC": {
      const userId = action.meta?.userId || action.payload?.user || "anon";
      // payload expected to be the session object returned by API
      return {
        ...state,
        loading: false,
        error: false,
        data: {
          ...state.data,
          [userId]: {
            ...(state.data[userId] || {}),
            loading: false,
            error: false,
            data: action.payload || {},
          },
        },
      };
    }

    case "SESSION_START_ERR": {
      const userId = action.meta?.userId || "anon";
      return {
        ...state,
        loading: false,
        error: true,
        data: {
          ...state.data,
          [userId]: {
            ...(state.data[userId] || {}),
            loading: false,
            error: true,
            startError: action.payload?.message || true,
          },
        },
      };
    }

    /* ===== END SESSION ===== */
    case "SESSION_END_REQ": {
      const userId = action.meta?.userId || "anon";
      return {
        ...state,
        // do not flip global loading; keep per-user flag
        data: {
          ...state.data,
          [userId]: {
            ...(state.data[userId] || {}),
            ending: true,
            endError: false,
          },
        },
      };
    }

    case "SESSION_END_SUC": {
      const userId = action.meta?.userId || action.payload?.user || "anon";
      // action.payload is end session object (with endedAt etc)
      // merge into existing user object and also keep lastEnded (or update data)
      const prev = state.data[userId] || {};
      return {
        ...state,
        data: {
          ...state.data,
          [userId]: {
            ...prev,
            ending: false,
            endError: false,
            // You might want to store both started session and ended session
            lastEnded: action.payload || {},
            // keep `data` as the last created session if desired
            data: {
              ...(prev.data || {}),
              // optionally update with ended info; but keep API payload under lastEnded
            },
          },
        },
      };
    }

    case "SESSION_END_ERR": {
      const userId = action.meta?.userId || "anon";
      const prev = state.data[userId] || {};
      return {
        ...state,
        data: {
          ...state.data,
          [userId]: {
            ...prev,
            ending: false,
            endError: true,
            endErrorMsg: action.payload?.message || true,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default sessionReducer;
